import DOM from '@/core/utils/dom';

/**
 * Базовый компонент для js компонентов, не имеет отношения к Vue
 */
class Component {

	static componentName = 'Top';

	componentName: string | undefined; // имя класса компонента
	className: string | undefined; // имя css класса компонента
	uid: string | undefined; // уникальный id компонента
	el: HTMLElement | undefined; // элемент, связанный с компонентом
	options = {}; // параметры компонента

	unmountEls: HTMLElement[] = [];
	unmountEvents: any[] = [];

	// переопредлять нельзя
	// если компонент инициирован, необходимо сразу его вернуть и выполнить reInit() вместо mount()
	// используется init вместо constructor, так как super constructor выполняется до Object.defineProperty() параметров класса
	init(componentName: string, el: HTMLElement, options: object): Component | void {
		if (!el) {
			throw componentName + ': el is undefined';
		}

		const component = Component.getComponent(el, componentName);

		if (component) {
			component.reInit(options);

			return component;
		}

		this.componentName = componentName;
		this.className = 'top' + componentName[0].toUpperCase() + componentName.substring(1);
		this.uid = this.componentName + (Math.random() + '').replace('.', '');

		this._setComponent(el);
		this.el = el;
		this.el.classList.add(this.className);
		this.options = Object.assign(this.options, options);

		this.mount();
	}

	// получить инициированный компонент
	static getComponent(el: HTMLElement, componentName: string): any {
		return DOM.storage(el, '#' + componentName);
	}

	// устанвоить компонент
	_setComponent(el: HTMLElement) {
		DOM.storage(el, '#' + this.componentName, this);
	}

	// функция подключения компонента
	mount(): void {
		throw 'Please, add method mount() to component: ' + this.componentName;
	}

	// функция отключения компонента
	unmount(): void {
		DOM.storage(this.el, '#' + this.componentName, null);

		this.unmountEls.forEach((el) => {
			el.remove();
		});

		this.unmountEls = [];

		this.unmountEvents.forEach((eventData) => {
			eventData.el.removeEventListener(eventData.type, eventData.listener, eventData.options);
		});

		this.unmountEvents = [];
	}

	// указание новые элементы, которые должны будут удалиться после unmount
	registerElForUnmount(el: HTMLElement): void {
		this.unmountEls.push(el);
	}

	// указание новые события, которые должны будут удалиться после unmount
	addEventListenerWithUnmount(
		el: HTMLElement | Document | Window,
		type: keyof GlobalEventHandlersEventMap,
		listener: (this: HTMLElement, e: Event) => any,
		options?: any,
	): void {
		el.addEventListener(type, listener, options);

		this.registerEventForUnmount(el, type, listener, options);
	}

	// указание новые события, которые должны будут удалиться после unmount
	registerEventForUnmount(
		el: HTMLElement | Document | Window,
		type: keyof GlobalEventHandlersEventMap,
		listener: (this: HTMLElement, e: Event) => any,
		options?: any,
	): void {
		const eventData = {
			el: el,
			type: type,
			listener: listener,
			options: options,
		};

		this.unmountEvents.push(eventData);
	}

	// функция перенастройки уже подключенного компонента
	reInit(_options: object): void {
		throw 'Please, add method reInit() to component: ' + this.componentName;
	}

	// удалить элементы из DOM, но не из памяти
	static detach(nodes: NodeList | HTMLElement): void {
		if (nodes instanceof NodeList) {
			nodes.forEach((node) => node.parentElement?.removeChild(node));
		} else {
			const el = nodes;
			el.parentElement?.removeChild(el);
		}
	}

}

export default Component;
